import { initialPagination, initialState, makeListEffects, makeListReducers } from '@/models/utils';

import { filtersConfig } from './utils';

const namespace = 'emailMessageTrace';

const EmailMessageTraceModel = {
  namespace,
  state: {
    ...initialState,
    orderBy: 'created desc',
    filtersConfig,
  },

  effects: {
    ...makeListEffects({
      namespace,
      fetchRoute: 'emailMessageTrace',
      fetchParams: 'emailMessageTrace',
    }),
    *openDrawerView({ payload }, { put }) {
      yield put({
        type: 'openDrawerViewReducer',
        payload,
      });
    },
    *fetchItemSelected({ payload }, { call, put }) {
      try {
        yield put({
          type: 'queryItemSelectedEmailMessageTrace',
          payload: {
            ...payload,
          },
        });
      } catch (error) {
        yield put({
          type: 'closeDrawerViewReducer',
          payload: {
            state: false,
          },
        });
      }
    },
    *closeDrawerView({ payload }, { put }) {
      yield put({
        type: 'closeDrawerViewReducer',
        payload,
      });
    },
  },
  reducers: {
    ...makeListReducers({
      initialPagination,
      initialState: {
        ...initialState,
        filtersConfig,
      },
    }),

    openDrawerViewReducer(state, { payload }) {
      return {
        ...state,
        id: payload.id,
        openView: payload.state,
        selectedItem: {},
        view: true,
      };
    },
    queryItemSelectedEmailMessageTrace(state, { payload }) {
      const selectedItem = state.list.find((item) => item.id === payload.id);
      return {
        ...state,
        selectedItem: selectedItem,
        id: payload.id,
      };
    },
    closeDrawerViewReducer(state, { payload }) {
      return {
        ...state,
        id: null,
        openView: payload.state,
        selectedItem: null,
        view: false,
      };
    },
  },
};

export default EmailMessageTraceModel;
